import {CrossLargeIcon} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import type {ActionCancelV2} from 'src/api/cargo-c2c/types'

import {ActionButton} from '../action-button'
import {CancelModal} from './CancelModal'
import {useSharedRouteCancel} from './hooks'

type Props = {
  action: ActionCancelV2
}

export const CancelButton = memo<Props>(function CancelButton({action}) {
  const {message, isPending, cancelHandler, openHandler, closeHandler} = useSharedRouteCancel(action)

  return (
    <>
      <ActionButton
        disabled={isPending}
        lead={<CrossLargeIcon />}
        loading={isPending}
        onPress={isPending ? undefined : openHandler}
        title={action.title}
      />
      {message && <CancelModal message={message} onCancel={cancelHandler} onClose={closeHandler} />}
    </>
  )
})
